// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

const OFFER_OPEN = false;

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  // Radar, export (décision de Maxime du 25/10/2026) : la liste des projets est la valeur du produit, seul le
  // gestionnaire l'exporte ; chacun exporte ses affaires (DealExportButton ne garde que les siennes hors
  // administrateur) ; contacts et sociétés restent aux administrateurs.
  if (params.action === "export") {
    if (params.resource === "projects") return role === "manager";
    if (params.resource === "deals") return true;
  }

  // Radar, « Offre et couverture » (décision de Maxime du 26/10/2026) : cachée à tous sauf au gestionnaire tant que
  // les prix se négocient avec le client. Pour la rouvrir, passer OFFER_OPEN à true.
  if (params.resource === "offer" && !OFFER_OPEN) return role === "manager";

  // Radar, « Abonnés » (conception du 27/10/2026) : pilotage des comptes, réservé au gestionnaire ; la base refuse
  // aussi ses fonctions (`manager_accounts`, `manager_side`, `manager_person`) à tout autre compte.
  if (params.resource === "subscribers") return role === "manager";

  // Radar, paramètres de la plateforme (décision de Maxime du 27/10/2026) : nom, logos, étapes des affaires et
  // secteurs valent pour tous les comptes ; seul le gestionnaire les change, et la base le refuse aussi aux autres
  // (migration 20261030030000).
  if (params.resource === "configuration") return role === "manager";

  // Radar, « Partenaires et territoires » (conception du 29/10/2026, § 7) : offres, licences et territoires, au seul
  // gestionnaire ; chaque membre invite ses partenaires depuis « Mes partenaires » ou une fiche.
  if (params.resource === "user_territories") return role === "manager";

  // Le gestionnaire (administrateur qui gère les abonnements) a tous les droits d'un administrateur.
  if (role === "admin" || role === "manager") {
    return true;
  }

  // Non admins can't access the sales resource
  if (params.resource === "sales") {
    return false;
  }

  // Radar : les autres exports sont réservés aux administrateurs (spec § 2), pour qu'un partenaire ne puisse pas
  // emporter son territoire en un clic.
  if (params.action === "export") {
    return false;
  }

  return true;
};
